import * as THREE from "three";
class XRController extends THREE.Group {
  constructor(index, gl) {
    super();
    this.inputSource = null;
    this.xrControllerModel = null;
    this.index = index;
    this.controller = gl.xr.getController(index);
    this.grip = gl.xr.getControllerGrip(index);
    this.hand = gl.xr.getHand(index);
    this.grip.userData.name = "grip";
    this.controller.userData.name = "controller";
    this.hand.userData.name = "hand";
    this.visible = false;
    this.add(this.controller, this.grip, this.hand);
    this._onConnected = this._onConnected.bind(this);
    this._onDisconnected = this._onDisconnected.bind(this);
    this.controller.addEventListener("connected", this._onConnected);
    this.controller.addEventListener("disconnected", this._onDisconnected);
  }
  _onConnected(event) {
    if (event.fake)
      return;
    if (!event.data)
      return;
    this.visible = true;
    this.inputSource = event.data;
    this.dispatchEvent(event);
  }
  _onDisconnected(event) {
    if (event.fake)
      return;
    this.visible = false;
    this.inputSource = null;
    this.dispatchEvent(event);
  }
  dispose() {
    this.controller.removeEventListener("connected", this._onConnected);
    this.controller.removeEventListener("disconnected", this._onDisconnected);
  }
}
export {
  XRController
};
//# sourceMappingURL=XRController.js.map
